import { createBrowserRouter } from 'react-router-dom'
import ErrorPage from './error/Error.page'
import { COUNTRY_URL } from './home/country/Country.navigator'
import { CountryPage } from './home/country/Country.page'
import { HOME_URL } from './home/home-list/HomeList.navigator'
import { HomeListPage } from './home/home-list/HomeList.page'
import { HomePage } from './home/Home.layout'
import { MENU_URL } from './menu/Menu.navigator'
import { MenuPage } from './menu/Menu.page'

export const router = createBrowserRouter([
  {
    element: <HomePage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: HOME_URL,
        element: <HomeListPage />
      },
      {
        path: COUNTRY_URL,
        element: <CountryPage />
      },
      {
        path: MENU_URL,
        element: <MenuPage />
      }
    ]
  }
])
